import { Alert, type AlertProps } from "@mui/material";
import moment from "moment";

import { Product } from "api/memberPortal/project/product/product.types";
import { addToDate } from "utils/timeUtils";

interface DueDateBannerProps {
  product: Product | undefined;
  props?: AlertProps;
  show: boolean;
}

const DueDateBanner = ({ product, show, ...props }: DueDateBannerProps) => {
  if (!show || !product || !product.posted_date) return;

  const dueDate = moment(addToDate(product.posted_date, 1, "weeks")).format(
    "MMMM DD, YYYY",
  );

  return (
    <Alert color="error" {...props}>
      The Proficiency Feedback Form must be completed by {dueDate}
    </Alert>
  );
};

export default DueDateBanner;
